<template>
    <div class="home">
     
      <EditarCotizacionHomeComponent />
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import EditarCotizacionHomeComponent from '@/components/EditarCotizacionHomeComponent.vue'
  
  export default {
    name: 'EditarCotizacionView',
    components: {
        EditarCotizacionHomeComponent
    }
  }
  </script>